import Card from "../../components/card/card";
import { tramites } from "../../utils/listadoTramites";
import styles from "./home.module.css";
import { SearchNroCliente } from "../../components/SearchNroCliente/SearchNroCliente";
import { Alert, Button } from "@mui/material";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";
import { useState } from "react";
import ModalCenter from "../../components/modal/modalCenter";
import UpdateProfile from "../../components/updateProfile/updateProfile";
import ReturnBackButton from "../../components/returnBackButton/ReturnBackButton";
const Home = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className={styles.container}>
      <ReturnBackButton url="/" />
      <Button
        startIcon={<PersonSearchRoundedIcon />}
        onClick={() => setShowModal(true)}
        color="info"
      >
        Conocer mi número de asociado.
      </Button>
      <ModalCenter show={showModal} setShow={setShowModal}>
        <SearchNroCliente hiddenLoginButton={true} />
      </ModalCenter>
      <div className={styles.cardContainer}>
        {tramites.map((tramite, i) => {
          return <Card key={i} tramite={tramite} />;
        })}
      </div>
      {/* <UpdateProfile /> */}
    </div>
  );
};

export default Home;
